/**
 * Environment configuration
 * Access environment variables with type safety and defaults
 */

export const env = {
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL || 'contactus@shopmuchmore.co.uk',
  platformUrl: import.meta.env.VITE_PLATFORM_URL || 'https://shopmuchmore.co.uk/',
  merchantPlatformUrl: import.meta.env.VITE_MERCHANT_PLATFORM_URL || 'https://merchant.shopmuchmore.co.uk/',

  // Social Media Links (empty string means not configured)
  social: {
    instagram: import.meta.env.VITE_SOCIAL_INSTAGRAM || '',
    x: import.meta.env.VITE_SOCIAL_X || '',
    linkedin: import.meta.env.VITE_SOCIAL_LINKEDIN || '',
    facebook: import.meta.env.VITE_SOCIAL_FACEBOOK || '',
    tiktok: import.meta.env.VITE_SOCIAL_TIKTOK || '',
  },
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
} as const
